var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-comment-item"},[_c('CommentHeader',{attrs:{"comment":_vm.comment}}),_c('div',{staticClass:"c-comment-item__body"},[_c('article',[_vm._v(" "+_vm._s(_vm.comment.text)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }